import {
  TICKET_CODE_AUTH_FAILURE,
  TICKET_CODE_NOT_FOUND_FAILURE,
  TICKET_CODE_FOUND_SUCCESS,
  TICKET_CODE_CHANGED,
  TICKET_CODE_IS_VALID,
  TICKET_CODE_IS_INVALID,
  START_VALIDATION_FETCH,
  ADD_TICKET_TO_SELL,
  SET_EVENT_INFO,
  DELETE_TICKET,
  EVENTS_FETCH_SUCCESS,
  REMOVE_TICKET_FROM_LISTS,
  TICKET_SELL_SUCCESS,
  KILL_SALES,
  START_RESALE_VERIFICATION_SEND,
  RESALE_VERIFICATION_SEND_SUCCESS,
  RESALE_VERIFICATION_SEND_FAILURE,
  START_RESALE_VERIFICATION_CONFIRM,
  RESALE_VERIFICATION_CONFIRM_SUCCESS,
  RESALE_VERIFICATION_CONFIRM_FAILURE,
  RESET_RESALE_VERIFICATION
} from '../actionTypes'
import sortBy from 'lodash/sortBy'
import moment from 'moment'
import { isTicketVerificationValid } from '../utility/ticket-verification'

export default function tickets(
  state = {
    ticketCode: '',
    valid: false,
    validationError: false,
    isFetching: false,
    inSell: [],
    ticketInfo: {},
    eventInfo: null,
    newest: { events: [], tickets: [] },
    validationMessage: null,
    validationTitle: null,
    resaleVerification: {
      isSending: false,
      isConfirming: false,
      codeSent: false,
      channel: null,
      masked: '',
      validTo: null,
      error: null
    },
    namedInfos: {},
    persistExpiresAt: moment()
      .add(1, 'h')
      .format()
  },
  action
) {
  switch (action.type) {
    case REMOVE_TICKET_FROM_LISTS:
      const newTickets = state.newest.tickets.filter(
        ticket => ticket.id !== action.ticketId
      )

      return {
        ...state,
        newest: { ...state.newest, tickets: newTickets }
      }
    case EVENTS_FETCH_SUCCESS:
      const newest = action.newest

      const events = []
      const eventIds = {}
      newest.events.forEach(event => {
        if (!eventIds[event.id]) {
          events.push(event)
          eventIds[event.id] = true
        }
      })

      newest.events = events
      sortBy(newest, ['event.sale_start_date'], ['desc'])
      return {
        ...state,
        newest
      }
    case DELETE_TICKET:
      const codeToRemove = action.ticketCode
      return {
        ...state,
        inSell: state.inSell.filter(ticket => ticket.code !== codeToRemove)
      }
    case RESALE_VERIFICATION_CONFIRM_SUCCESS:
      return {
        ...state,
        ticketInfo: {
          ...state.ticketInfo,
          verified: true,
          verifiedUntil: action.validTo || state.ticketInfo.verifiedUntil
        },
        inSell: state.inSell.map(ticket =>
          ticket.code === action.ticketCode
            ? {
                ...ticket,
                verified: true,
                verifiedUntil: action.validTo || ticket.verifiedUntil
              }
            : ticket
        ),
        resaleVerification: {
          ...state.resaleVerification,
          isConfirming: false,
          error: null
        }
      }
    case START_RESALE_VERIFICATION_SEND:
      return {
        ...state,
        resaleVerification: {
          ...state.resaleVerification,
          isSending: true,
          error: null
        }
      }
    case RESALE_VERIFICATION_SEND_SUCCESS:
      return {
        ...state,
        resaleVerification: {
          isSending: false,
          isConfirming: false,
          codeSent: true,
          channel: action.channel,
          masked: action.masked,
          validTo: action.validTo,
          error: null
        }
      }
    case RESALE_VERIFICATION_SEND_FAILURE:
      return {
        ...state,
        resaleVerification: {
          ...state.resaleVerification,
          isSending: false,
          error: action.message
        }
      }
    case START_RESALE_VERIFICATION_CONFIRM:
      return {
        ...state,
        resaleVerification: {
          ...state.resaleVerification,
          isConfirming: true,
          error: null
        }
      }
    case RESALE_VERIFICATION_CONFIRM_FAILURE:
      return {
        ...state,
        resaleVerification: {
          ...state.resaleVerification,
          isConfirming: false,
          error: action.message
        }
      }
    case RESET_RESALE_VERIFICATION:
      return {
        ...state,
        resaleVerification: {
          isSending: false,
          isConfirming: false,
          codeSent: false,
          channel: null,
          masked: '',
          validTo: null,
          error: null
        }
      }
    case KILL_SALES:
      return {
        ...state,
        inSell: []
      }
    case ADD_TICKET_TO_SELL:
      return {
        ...state,
        ticketCode: '',
        inSell: [...state.inSell, state.ticketInfo],
        ticketInfo: {},
        valid: false
      }
    case SET_EVENT_INFO:
      return {
        ...state,
        eventInfo: action.eventInfo
      }
    case START_VALIDATION_FETCH:
      return {
        ...state,
        isFetching: true,
        validationTitle: null,
        resaleVerification: {
          isSending: false,
          isConfirming: false,
          codeSent: false,
          channel: null,
          masked: '',
          validTo: null,
          error: null
        }
      }
    case TICKET_CODE_AUTH_FAILURE:
      return {
        ...state,
        validationError: true,
        valid: false,
        isFetching: false,
        validationTitle: action.title,
        validationMessage: action.message
      }
    case TICKET_CODE_NOT_FOUND_FAILURE:
      return {
        ...state,
        validationError: true,
        isFetching: false,
        valid: false,
        validationTitle: null,
        validationMessage: action.message
      }
    case TICKET_CODE_FOUND_SUCCESS: {
      const ticket = action.body.ticket
      const needsVerification =
        ticket.verification &&
        ticket.verification.available &&
        !isTicketVerificationValid(ticket)

      return {
        ...state,
        valid: true,
        isFetching: false,
        ticketInfo: {
          ...ticket,
          verifiedUntil: ticket.verifiedUntil || null
        },
        validationError: false,
        validationMessage: null,
        validationTitle: null,
        resaleVerification: {
          isSending: false,
          isConfirming: false,
          codeSent: false,
          channel: needsVerification ? ticket.verification.channel : null,
          masked: needsVerification ? ticket.verification.masked : '',
          validTo: null,
          error: null
        }
      }
    }
    case TICKET_CODE_CHANGED:
      return {
        ...state,
        ticketCode: action.ticketCode,
        validationError: false,
        validationTitle: null,
        resaleVerification: {
          isSending: false,
          isConfirming: false,
          codeSent: false,
          channel: null,
          masked: '',
          validTo: null,
          error: null
        }
      }
    case TICKET_CODE_IS_VALID:
      return {
        ...state,
        valid: true
      }
    case TICKET_CODE_IS_INVALID:
      return {
        ...state,
        valid: false
      }
    case TICKET_SELL_SUCCESS:
      return {
        ...state,
        inSell: []
      }
    default:
      return state
  }
}
